import React, { useState } from 'react';
import "./style.css"
// import axios from 'axios';
// import { useDownloadOrderDataQuery } from "../../Services/DasboardAPI"

const ReportDownloadPage = () => {
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const handleDownload = async (type) => {
        if (!fromDate || !toDate) {
            alert('Please select both From and To dates');
            return;
        }

        try {
            const token = localStorage.getItem("accessToken");
            const response = await fetch(
                `${process.env.REACT_APP_BASEURL_SERVER}admin/orders/export-items?from=${fromDate}&to=${toDate}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/pdf',
                        'accept': 'application/pdf',
                        'Authorization': `Bearer ${token}`
                        // Add Authorization header if needed:
                        // 'Authorization': `Bearer ${yourToken}`,
                    },
                }
            );

            if (!response.ok) throw new Error('Network response was not ok');

            console.log("response", response)

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `order_report_${fromDate}_to_${toDate}.xlsx`); // or `.csv`
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            console.error(error);
            alert('Failed to download report');
        }
    };


    return (
        <div className="p-6 max-w-xl mx-auto download-reports">
            <h2 className="text-xl font-bold mb-4">Download Reports</h2>
            <hr className='mb-5' />

            <div className="flex gap-4 mb-4">
                <div className="w-1/2 date-field">
                    <label className="block mb-1 font-medium"><b>From Date:</b></label>
                    <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        className="border p-2 w-full"
                    />
                </div>

                <div className="w-1/2 date-field">
                    <label className="block mb-1 font-medium"><b>To Date:</b></label>
                    <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        className="border p-2 w-full"
                    />
                </div>
            </div>

            <div className="flex gap-4">
                <button
                    className="btn-primary"
                    onClick={() => handleDownload('orders')}
                >
                    Download Order Report
                </button>
            </div>
        </div>

    );
};

export default ReportDownloadPage;
